/**
 * BottomNavBar - Frosted glass bottom navigation
 *
 * Semi-transparent background + backdrop-blur.
 * Frosted glass effect becomes visible when page content scrolls behind the nav.
 */

export interface NavItem {
  id: string
  icon: string
  label: string
}

export interface BottomNavBarProps {
  items: NavItem[]
  active: string
  onNavigate?: (id: string) => void
  className?: string
}

export function BottomNavBar({ items, active, onNavigate, className: _className }: BottomNavBarProps) { // eslint-disable-line @typescript-eslint/no-unused-vars
  return (
    <nav
      className="fixed bottom-0 left-0 w-full z-50 bg-canvas/95 backdrop-blur-xl rounded-t-xl shadow-subtle"
      role="navigation"
      aria-label="Main navigation"
    >
      <div className="flex justify-around items-center px-4 py-3 pb-safe">
        {items.map((item) => {
          const isActive = active === item.id
          return (
            <button
              key={item.id}
              onClick={() => onNavigate?.(item.id)}
              className={
                'flex flex-col items-center justify-center transition-all duration-200 active:scale-95 ' +
                (isActive
                  ? 'bg-surface-soft text-ink rounded-full px-6 py-2 hover:scale-105'
                  : 'text-muted px-6 py-2 hover:scale-105')
              }
              aria-label={item.label}
              aria-current={isActive ? 'page' : undefined}
            >
              <span
                className="material-symbols-outlined mb-1"
                style={{ fontVariationSettings: isActive ? "'FILL' 1" : undefined }}
              >
                {item.icon}
              </span>
              <span className="text-[12px] font-bold uppercase tracking-wider">{item.label}</span>
            </button>
          )
        })}
      </div>
    </nav>
  )
}
